module.exports = __webpack_public_path__ + "fd3dd8f0ba9e7e89f82bcdeba6495fff.png";